import { getRecoil } from "recoil-nexus";
import TerminalSwarmActions from "./swarmActions/terminal";
import { ISelection } from "src/constants/interfaces/bet";
import mainStore from "src/stores/main";
import upperDataStore from "src/stores/upperData";
import { decimalString } from "src/constants/types";
import { BetTypeEnum } from "src/constants/enums/betType";

export const bookBet = async (selections: ISelection[], amount: decimalString) => {
  const { betType, systemCombinationCount } = getRecoil(mainStore);
  const { authData } = getRecoil(upperDataStore);

  const request = {
    cashdesk_id: authData.tid,
    bets: [
      {
        Amount: amount,
        BetType: betType,
        SystemMinCount: betType === BetTypeEnum.System ? systemCombinationCount : null,
        Selections: selections.map(selection => ({
          SelectionId: selection.event.id,
          IsBanker: selection.isBanker,
          Price: selection.event.price,
          // Stamp the match id on bet builder legs so the backend can
          // reconstruct the combined card. Regular selections leave the
          // field undefined and it gets stripped from the JSON payload.
          ...(selection.event.isInternalBetBuilder && {
            BetBuilderMatchId: selection.game.id,
          }),
        })),
      },
    ],
  };

  return await TerminalSwarmActions.bookBet(request);
};
